<button [disabled]="!adminFlag" mat-button color="primary" (click)="onClick()">
  <mat-icon>file_upload</mat-icon>
  {{text}}
</button>
<br/>

<input type="file" id="fileUpload" name="fileUpload"  accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xlsx,.xls" style="display:none;"/>